<template>
  <div id="editPropCategory">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{ $t('LanguageLib.PROP_CATEGORY_INFO') }}</span>
    </div>
    <div class="content">
      <el-button @click="submit('ruleForm')" type="primary" class="searchBtn" :loading="loadingSave"
                 style="margin-bottom: 7px;">{{$t('LanguageLib.SAVE')}}
      </el-button>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm">
        <template v-if="type==='edit'">
          <h4>{{$t('LanguageLib.BASIC_CONFIGURATION')}}</h4>
          <div class="contentTop">
            <el-checkbox v-model="ruleForm.stackShelves">{{$t('LanguageLib.STACK_SHELVES')}}</el-checkbox>
          </div>
        </template>
        <div class="contentInfo">
          <h4>{{$t('LanguageLib.BASIC_INFORMATION')}}</h4>
          <div class="infoForm">

            <!-- 道具封面-->
            <div class="storePic parent" style="float: left;" v-if="parentLevel==2">
              <div class="parent" style="width: auto;">
                <img v-if="ruleForm.propThumbnail != '' && ruleForm.propThumbnail != null"
                     :src="ruleForm.propThumbnail"/>
                <img v-if="ruleForm.propThumbnail == '' || ruleForm.propThumbnail == null"
                     src="@/assets/images/storeCover.png"/>
                <p class="drawerText" style="white-space: nowrap;">{{$t('LanguageLib.PROPS_CATEGORY_PICTURES')}}</p>
              </div>
              <div class="parent" style="margin-left: 10px;width: auto;top: 18px">
                <el-button size="small" type="primary">{{$t('LanguageLib.UPLOAD_IMAGE')}}</el-button>
                <div v-if="ruleForm.propThumbnail !== '' && ruleForm.propThumbnail !== null">
                  <el-button size="small" type="primary" @click="deletePic"
                             style="background: #ffffff;border: #3bc6b9 solid 1px;color: #3bc6b9">
                    {{$t('LanguageLib.DELETE_IMG')}}
                  </el-button>
                </div>
                <div v-if="ruleForm.propThumbnail === '' || ruleForm.propThumbnail == null">
                  <el-button size="small" type="primary" @click="deletePic"
                             :disabled="true"
                             style="background: #ffffff;border: #d8dce6 solid 1px;color: #C0C4CC">
                    {{$t('LanguageLib.DELETE_IMG')}}
                  </el-button>
                </div>
                <input ref="referenceUpload" type="file" id="uploads"
                       accept="image/png, image/jpeg, image/jpg, image/PNG, image/JPG, image/bmp"
                       @change="uploadImg($event, 1)">
              </div>
            </div>

            <!--序号-->
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.SERIAL_NUMBER')}}</p>
              <el-form-item>
                <el-input style="width: 320px;" oninput="this.value=this.value.replace(/[^\d]/g,'');"
                          :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.serialNumber" maxlength="9">
                </el-input>
              </el-form-item>
            </div>
            <!--            类别名称-->
            <div class="parent">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.CLASSIFICATION_NAME')}}</p>
              <el-form-item style="min-width: 700px" prop="categoryName">
                <el-input style="width: 320px;display: inline-block" :placeholder="$t('LanguageLib.PleaseEnter')"
                          v-model="ruleForm.categoryName"
                          maxlength="50">
                </el-input>
              </el-form-item>
            </div>

            <!--          上级分类-->
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.SUBHEADINGS')}}</p>
              <el-form-item>
                <el-input style="width: 320px;" class="TeInput" v-model="ruleForm.parent.name"
                          :placeholder="$t('LanguageLib.PLEASE_CHOOSE')"
                          :disabled="subDisabled">
                  <el-button @click="openCategoryList" class="openOrgList" slot="append" :style="styleStrRegion"
                             :disabled="subDisabled"
                             icon="el-icon-more"></el-button>
                </el-input>
              </el-form-item>
            </div>

            <el-dialog :visible.sync="showDialog" :title="$t('LanguageLib.SELECT_CATEGORY')">
              <category-tree @addcheck-treedata="getTreeCheckDataCategory" :categoryData="categoryData"
                             :checkCategoryId="ruleForm.parent.id"
                             :oneNodeArr="categoryOpenArr"
                             :categoryTreeData="categoryTreeData"
                             labelName="category"
              >

              </category-tree>
              <el-button style="float:right;margin-top:15px;" @click="confirmParentCategory" type="primary"
                         class="searchBtn">{{$t('LanguageLib.DETERMINE')}}
              </el-button>
            </el-dialog>

            <!--            英文名称-->
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.ENGLISH_NAME')}}</p>
              <el-form-item style="min-width: 700px">
                <el-input style="width: 320px;display: inline-block" :placeholder="$t('LanguageLib.PleaseEnter')"
                          v-model="ruleForm.categoryName_EN"
                          maxlength="50">
                </el-input>
              </el-form-item>
            </div>

            <el-dialog :title="$t('LanguageLib.PICTURE_CAPTURE')" :visible.sync="cropImageDialog"
                       class="cropImageForm dialogStoreComm" :close-on-click-modal="false">
              <div class="cropper-content">
                <div class="cropper">
                  <vueCropper
                    ref="cropper"
                    :centerBox="true"
                    :img="option.img"
                    :outputSize="option.size"
                    :outputType="option.outputType"
                    :info="true"
                    :full="option.full"
                    :canMove="option.canMove"
                    :canMoveBox="option.canMoveBox"
                    :original="option.original"
                    :autoCrop="option.autoCrop"
                    :autoCropWidth="option.autoCropWidth"
                    :autoCropHeight="option.autoCropHeight"
                    :fixedBox="option.fixedBox"
                    :fixedNumber="[1,1]"
                    :fixed="true"
                    @realTime="realTime"
                    @imgLoad="imgLoad"
                  >
                  </vueCropper>
                </div>
              </div>
              <div class="footer-btn">
                <div class="scope-btn">
                  <div class="buttonSlot" @click="changeScale(1)" :title="$t('LanguageLib.ENLARGE')">
                    <div class="buttonContent"><i class="iconfont">&#xe607;</i></div>
                    <div class="buttonContent text">{{$t('LanguageLib.ENLARGE')}}</div>
                  </div>
                  <div class="buttonSlot" @click="changeScale(-1)" :title="$t('LanguageLib.NARROW')">
                    <div class="buttonContent"><i class="iconfont">&#xe608;</i></div>
                    <div class="buttonContent text">{{$t('LanguageLib.NARROW')}}</div>
                  </div>
                  <div class="buttonSlot" @click="rotateLeft" :title="$t('LanguageLib.TURN_LEFT')">
                    <div class="buttonContent"><i class="iconfont">&#xe605;</i></div>
                    <div class="buttonContent text">{{$t('LanguageLib.TURN_LEFT')}}</div>
                  </div>
                  <div class="buttonSlot" @click="rotateRight" :title="$t('LanguageLib.TURN_RIGHT')">
                    <div class="buttonContent"><i class="iconfont">&#xe609;</i></div>
                    <div class="buttonContent text">{{$t('LanguageLib.TURN_RIGHT')}}</div>
                  </div>
                </div>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button :loading="isLoading" style="margin-left:20px" type="primary" :style="'margin-left: 46px'"
                           @click="down('base64')">{{$t('LanguageLib.DETERMINE')}}
                </el-button>
              </div>
            </el-dialog>

          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import storeMntApi from '../../api/storeMnt'
import storeinformationApi from '../../api/storeinformation'
import categoryTree from '@/components/categoryTree.vue'
import { VueCropper } from 'vue-cropper'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

export default {
  name: 'EditMntCategory',
  components: {
    categoryTree,
    VueCropper
  },
  data () {
    var checkCategoryName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.CLASSIFICATION_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.CLASSIFICATION_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    return {
      isLoading: false,
      sub: {
        id: '',
        categoryCode: '',
        category: ''
      },
      cropImageDialog: false,
      parentId: '',
      categoryData: [],
      categoryTreeData: [],
      categoryOpenArr: [],
      categoryObj: {},
      type: '',
      rules: {
        categoryName: [
          {
            validator: checkCategoryName,
            trigger: 'blur'
          }
        ]
      },
      OwnerLanguage: 0, // 公司默认语言
      currentLang: '',
      langList: [],
      parentLevel: '',
      showDialog: false,
      level: '',
      loadingSave: false,
      styleStrRegion: '',
      downImg: '#',
      ruleForm: {
        categoryName_EN: '', // 英文名
        categoryName: '', // 类别名称
        parent: {
          id: '',
          name: ''
        }, // 上级分类
        serialNumber: 0,
        stackShelves: true,
        propThumbnail: ''
      },
      option: {
        img: '',
        size: 1,
        full: false,
        outputType: 'png',
        canMove: true,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        autoCropWidth: 200,
        autoCropHeight: 200,
        fixedBox: true,
        fixedNumber: [1, 1]
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.3
    })
    NProgress.start()
    const q = decodeURIComponent(to.query.myQuery)
    const query = JSON.parse(q)
    const type = query.type
    console.log(query)
    if (type === 'edit') {
      storeMntApi.getPropCategoryDetail('get', '/prop/getPropCategory?propCategoryId=' + query.categoryObj.id)
        .then(res => {
          NProgress.done()
          next(vm => {
            vm.categoryObj = res.data
            const obj = vm.categoryObj
            console.log(obj)
            vm.ruleForm.parent.id = obj.parentID.toUpperCase()
            vm.ruleForm.propThumbnail = obj.thumbFileId
            vm.ruleForm.categoryName = obj.category
            vm.ruleForm.categoryName_EN = obj.category_EN
            vm.ruleForm.serialNumber = obj.categoryCode
            vm.ruleForm.stackShelves = obj.isEnable
          })
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    } else {
      storeMntApi.getPropSerialNumber('get', '/prop/sortno')
        .then(
          res => {
            NProgress.done()
            next(vm => {
              vm.ruleForm.parent.id = query.parentId.toUpperCase()
              vm.ruleForm.serialNumber = res.data
            })
          })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    }
  },
  computed: {
    subDisabled () {
      // 添加状态
      if (this.type === 'add') {
        return true
      } else {
        // 编辑状态
        if (this.parentLevel === 0) {
          return true
        } else {
          return false
        }
      }
    }
  },
  created () {
    const query = JSON.parse(this.$commonfun.decodeUrl(this.$route.query.myQuery))
    this.type = query.type
    this.showDisabled = query.showDisabled
    this.getLangList()
    this.getCategoryTreeData()
  },
  methods: {
    // 截取上传
    down (type) {
      // event.preventDefault()
      if (!this.option.img) {
        this.$message.success(this.$t('LanguageLib.PLEASE_SELECT_A_PICTURE'))
        return
      }
      this.isLoading = true
      var aLink = document.createElement('a')
      aLink.download = 'author-img'
      // 输出
      if (type === 'blob') {
        this.$refs.cropper.getCropBlob(data => {
          this.downImg = window.URL.createObjectURL(data)
          aLink.href = window.URL.createObjectURL(data)
          aLink.click()
        })
      } else {
        this.$refs.cropper.getCropData(data => {
          this.downImg = data
          const that = this
          var canvas = document.createElement('canvas')
          canvas.width = 640
          canvas.height = 640
          var ctx = canvas.getContext('2d')
          // 创建img
          var image = new Image()
          image.src = data
          var dataNew, blob
          image.onload = function () {
            ctx.drawImage(image, 0, 0, 640, 640)
            dataNew = canvas.toDataURL()
            blob = that.convertBase64UrlToBlob(dataNew)
            const formData = new FormData()
            blob.name = 'cover.jpg'
            formData.append('file', blob, blob.name)
            formData.append('path', 'images')
            storeinformationApi.uploadImg('post', '/api/FileUpload', formData, 'webUrl')
              .then(res => {
                that.cropImageDialog = false
                that.isLoading = false
                that.ruleForm.propThumbnail = res.data[0]
              })
              .catch(err => {
                this.$commonfun.console.log(err)
                that.isLoading = false
              })
          }
        })
      }
    },

    imgLoad (msg) {
    },

    // 放大/缩小
    changeScale (num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    // 左旋转
    rotateLeft () {
      this.$refs.cropper.rotateLeft()
    },
    // 右旋转
    rotateRight () {
      this.$refs.cropper.rotateRight()
    },
    finish (type) {
      // 输出
      // var test = window.open('about:blank')
      // test.document.body.innerHTML = '图片生成中..'
      if (type === 'blob') {
        this.$refs.cropper.getCropBlob(data => {
          var img = window.URL.createObjectURL(data)
          this.model = true
          this.modelSrc = img
        })
      } else {
        this.$refs.cropper.getCropData(data => {
          this.model = true
          this.modelSrc = data
        })
      }
    },
    // 实时预览函数
    realTime (data) {
      this.previews = data
    },
    // 图片转blob
    convertBase64UrlToBlob (urlData) {
      const bytes = window.atob(urlData.split(',')[1]) // 去掉url的头，并转换为byte
      // 处理异常,将ascii码小于0的转换为大于0
      const ab = new ArrayBuffer(bytes.length)
      const ia = new Uint8Array(ab)
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i)
      }
      return new Blob([ab], {
        type: 'image/jpg'
      })
    },

    deletePic () {
      this.$commonfun.confirm(this.$t('LanguageLib.ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT1'), this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          this.ruleForm.propThumbnail = ''
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('LanguageLib.DeletionCancelled')
          })
        })
    },
    // 上传图片
    uploadImg (e, num) {
      // 上传图片
      this.$commonfun.console.log(e.target)
      var file = e.target.files[0]
      if (!/\.(jpg|jpeg|png|bmp|JPG|PNG)$/.test(e.target.value)) {
        this.$message.success(this.$t('LanguageLib.PLEASE_SELECT_CORRECT_PICTURE_FORMAT'))
        return false
      }
      var reader = new FileReader()
      reader.onload = e => {
        let data
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        if (num === 1) {
          this.cropImageDialog = true
          this.$refs.referenceUpload.value = null
          this.option.img = data
        } else if (num === 2) {
          this.example2.img = data
        }
      }
      // 转化为base64
      reader.readAsDataURL(file)
    },
    // 根据分类判断等级
    getCategoryLevel (id) {
      if (id === this.ownerId) {
        return 0
      }
      const pr = this.categoryData.find(x => x.id === id)
      return pr.level
    },
    // 确定更改上级分类
    confirmParentCategory () {
      this.showDialog = false
      this.ruleForm.parent.id = this.sub.id
      this.ruleForm.parent.name = this.sub.category
      this.parentLevel = this.getCategoryLevel(this.ruleForm.parent.id)
    },
    getCategoryTreeData () {
      const url = this.showDisabled === true ? '/prop/getPropCategoryTree?showDisable=true' : '/prop/getPropCategoryTree?showDisable=false'
      storeMntApi.getPropCategoryTree('get', url)
        .then(res => {
          // 只要调用树接口,就一定要给树赋新的值
          // 不管你第几次进来,都是直接把值刷新,然后塞新的假根节点
          this.categoryData = res.data
          console.log(this.categoryData)
          this.ownerId = this.$commonfun.localStorage.getitem('ownerId').toUpperCase()
          if (!this.ownerId) {
            this.ownerId = res.data[0].ownerID.toUpperCase()
          }
          this.categoryData.forEach(x => {
            x.id = x.id.toUpperCase()
            x.parentID = x.parentID.toUpperCase()
            x.ownerID = x.ownerID.toUpperCase()

            if (x.id === this.ruleForm.parent.id) {
              this.ruleForm.parent.name = x.category
              this.parentLevel = x.level
            }
          })
          if (this.ruleForm.parent.name === '' && this.ruleForm.parent.id === this.ownerId) {
            this.ruleForm.parent.name = this.$t('LanguageLib.ITEM_CLASSIFICATION')
            this.parentLevel = 0
          }

          let ctd
          // 如果是一级数据,无上级分类,置灰上级分类
          if (this.parentLevel === 0) {
            const area = {
              category: this.$t('LanguageLib.ITEM_CLASSIFICATION'),
              parentID: '',
              categoryCode: null,
              ownerID: this.ownerId,
              id: this.ownerId
            }
            this.categoryData.unshift(area)
            ctd = this.$commonfun.toCategoryTree(res.data, 'childCategoryTrees', 'id', 'parentID')
            ctd.forEach(x => {
              x.id = x.id.toUpperCase()
              x.parentID = x.parentID.toUpperCase()
              x.ownerID = x.ownerID.toUpperCase()
            })
          } else if (this.parentLevel === 1) {
            // 如果是二级数据,把类别data筛选一下,只保留一级数据
            const level1 = res.data.filter(x => x.level === 1)
            ctd = level1
            ctd.forEach(x => {
              x.id = x.id.toUpperCase()
              x.parentID = x.parentID.toUpperCase()
              x.ownerID = x.ownerID.toUpperCase()
            })
          } else {
            // 如果是三级数据,把类别data筛选,保留二级数据
            const level2 = res.data.filter(x => x.level === 2)
            ctd = level2
            ctd.forEach(x => {
              x.id = x.id.toUpperCase()
              x.parentID = x.parentID.toUpperCase()
              x.ownerID = x.ownerID.toUpperCase()
            })
          }
          this.categoryTreeData = ctd
        }).catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    getTreeCheckDataCategory (data) {
      this.sub = data
    },

    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type === 'add') {
            const newProp = {}
            newProp.category = this.ruleForm.categoryName
            newProp.category_EN = this.ruleForm.categoryName_EN
            newProp.level = this.parentLevel + 1
            newProp.parentID = this.ruleForm.parent.id
            newProp.categoryCode = this.ruleForm.serialNumber
            newProp.thumbFileId = this.ruleForm.propThumbnail

            storeMntApi.createPropCategory('post', '/prop/createPropCategory', newProp)
              .then(res => {
                const qr = JSON.parse(this.$commonfun.decodeUrl(this.$route.query.myQuery))
                const x = {
                  isSearch: qr.isSearch,
                  batchDisabled: qr.batchDisabled,
                  showDisabled: qr.showDisabled,
                  currentPage: qr.currentPage,
                  pageSize: qr.pageSize,
                  searchText: qr.searchText,
                  sort: qr.sort,
                  sortOrder: qr.sortOrder,
                  type: 'add',
                  parentId: qr.parentId
                }
                const myQuery = this.$commonfun.encodeUrl(JSON.stringify(x))
                this.$router.push({
                  path: '/storemnt/propcategory',
                  query: {
                    fromPath: 'editpropcategory',
                    myQuery: myQuery
                  }
                })
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
          } else {
            const editProp = {}
            editProp.id = this.categoryObj.id
            editProp.category = this.ruleForm.categoryName
            editProp.category_EN = this.ruleForm.categoryName_EN
            editProp.level = this.parentLevel + 1
            editProp.isEnable = this.ruleForm.stackShelves
            editProp.ownerID = this.categoryObj.ownerID
            editProp.parentID = this.ruleForm.parent.id
            editProp.categoryCode = this.ruleForm.serialNumber
            editProp.thumbFileId = this.ruleForm.propThumbnail

            storeMntApi.updatePropCategory('post', '/prop/updatePropCategory', editProp)
              .then(res => {
                const qr = JSON.parse(this.$commonfun.decodeUrl(this.$route.query.myQuery))
                const x = {
                  isSearch: qr.isSearch,
                  batchDisabled: qr.batchDisabled,
                  showDisabled: qr.showDisabled,
                  currentPage: qr.currentPage,
                  pageSize: qr.pageSize,
                  searchText: qr.searchText,
                  sort: qr.sort,
                  sortOrder: qr.sortOrder,
                  type: 'edit',
                  parentId: qr.parentId
                }
                const myQuery = this.$commonfun.encodeUrl(JSON.stringify(x))
                this.$router.push({
                  path: '/storemnt/propcategory',
                  query: {
                    fromPath: 'editpropcategory',
                    myQuery: myQuery
                  }
                })
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
          }
        }
      })
    },
    goReturn () {
      const qr = JSON.parse(this.$commonfun.decodeUrl(this.$route.query.myQuery))
      const x = {
        isSearch: qr.isSearch,
        batchDisabled: qr.batchDisabled,
        showDisabled: qr.showDisabled,
        currentPage: qr.currentPage,
        pageSize: qr.pageSize,
        searchText: qr.searchText,
        sort: qr.sort,
        sortOrder: qr.sortOrder,
        type: 'edit',
        parentId: qr.parentId
      }
      const myQuery = this.$commonfun.encodeUrl(JSON.stringify(x))
      this.$router.push({
        path: '/storemnt/propcategory',
        query: {
          fromPath: 'editpropcategory',
          myQuery: myQuery
        }
      })
    },
    getLangList () {
      // 获取店铺多语言列表
      storeinformationApi.getLang('get', '/BasicData/GetLang', {
        pageIndex: 1,
        pageSize: 2147483647
      })
        .then(res => {
          var OwnerLanguage = this.$commonfun.localStorage.getitem('OwnerLanguage') * 1
          this.OwnerLanguage = OwnerLanguage
          this.langList = res.data
          this.multiLinguals = this.langList.map(x => {
            x.categoryName = ''
            return x
          })
          this.langList = this.langList.map(x => {
            const obj = {}
            obj.id = x.typeValue
            obj.content = x.typeDes
            if (obj.id === OwnerLanguage) {
              this.currentLang = OwnerLanguage
            }
            return obj
          })
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    openCategoryList () {
      if (this.type === 'edit') {
        this.showDialog = true
      }
    }
  }

}
</script>

<style lang="scss">
  #editPropCategory {
    height: 100%;
    width: 100%;

    .buttonSlot {
      padding: 0 4px;
      color: white;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border-radius: 5%;
      cursor: pointer;
      width: 98px;
      margin: 0 1px;
      text-overflow: ellipsis;
      overflow: hidden;
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      height: 30px;
      margin-bottom: 15px;

      .buttonContent {
        display: inline-block;
        margin-right: 3px;
      }

      .buttonContent.text {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .storePic {
      overflow: hidden;

      .parent {
        float: left;
        width: auto;
        position: relative;
        margin-bottom: 16px;

        img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          border: 1px solid #E1E1E1;
        }

        .drawerText {
          width: 100px;
          text-align: center;
          margin-top: 4px;
        }

        input {
          position: absolute;
          left: 10px;
          width: calc(100% - 10px);
          height: 30px;
          top: 0;
          opacity: 0;
        }

        .el-button--primary {
          margin-left: 2px;
          display: inherit;
          margin-bottom: 8px;
          font-size: 14px;
        }

        .el-button--primary:nth-of-type(2) {
          background: #fff;
          color: #C0C4CC;
          border: 1px solid rgba(216, 220, 230, 1);
        }
      }
    }

    .TeInput input {
      border-right: 0px;
      border-radius: 4px 0 0 4px;
    }

    .left {
      width: 320px !important;
    }

    .return {
      padding-left: 25px;
      position: relative;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      line-height: 50px;
      border-bottom: 1px solid #F2F2F2;

      .el-icon-back {
        margin-right: 15px;
        cursor: pointer;
      }

      .border {
        position: absolute;
        height: 37px;
        border-left: 1px solid #f1f1f1;
        display: inline-block;
        top: 5px;
      }

      .title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-left: 15px;
      }
    }

    .content::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    .content::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }

    .content::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: #fff;
    }

    .content {
      background: rgba(255, 255, 255, 1);
      width: 100%;
      height: calc(100% - 66px);
      overflow-y: auto;
      overflow-x: hidden;
      padding: 0 100px;
      padding-top: 15px;
      box-sizing: border-box;

      /*组织树视图*/
      .el-dialog {
        overflow: hidden;
        width: 360px !important;

        .left {
          background: #fff;
          width: 320px;
          height: 535px;
          border: 1px solid #f2f2f2;

          .fifter {
            height: 30px;
            padding: 10px 0 10px 20px;
            margin: 0 auto;
            border-bottom: 1px solid #f2f2f2;

            .el-input {
              width: 220px;

              input {
                height: 30px;
                line-height: 30px;
                border-radius: 20px;
              }

              .el-icon-search {
                line-height: 30px;
              }
            }

            .el-button--text {
              margin-left: 8px;
              padding: 7px 0;
              color: #3BC6B9;
            }
          }

          .treeBox {
            height: calc(100% - 51px);
            overflow: auto;
            width: 320px;
          }

          .treeBox::-webkit-scrollbar {
            width: 10px;
            height: 10px;
          }

          .treeBox::-webkit-scrollbar-thumb {
            border-radius: 5px;
            -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
            background: #E1E1E1;
          }

          .treeBox::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
            border-radius: 5px;
            background: #fff;
          }
        }
      }

      .el-textarea__inner {
        font: 400 13.3333px Arial;
      }

      .cropper-content {
        background: #f2f2f2;
        padding-top: 20px;
        /*display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        -webkit-justify-content: flex-end;*/
        .cropper {
          width: 400px;
          height: 400px;
          margin: 0 auto;
        }

        .show-preview {
          flex: 1;
          -webkit-flex: 1;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          -webkit-justify-content: center;

          .preview {
            overflow: hidden;
            border-radius: 50%;
            border: 1px solid #cccccc;
            background: #cccccc;
            margin-left: 40px;
          }
        }
      }

      .footer-btn {
        padding-top: 20px;
        background: #f2f2f2;
        /*display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        -webkit-justify-content: flex-end;*/
        .scope-btn {
          width: 400px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          -webkit-justify-content: space-between;
          margin: 0 auto;

          .el-button--primary {
            max-width: 98px;
            margin: 0 1px;
            text-overflow: ellipsis;
            overflow: hidden;
            background-color: #3BC6B9;
            border-color: #3BC6B9;
            height: 30px;
            margin-bottom: 15px;
            margin-left: 0;
          }

          span {
            display: block;
            float: left;
          }
        }

        .upload-btn {
          flex: 1;
          -webkit-flex: 1;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          -webkit-justify-content: center;
        }
      }

      .label-success {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        -webkit-appearance: none;
        text-align: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        -webkit-transition: 0.1s;
        transition: 0.1s;
        font-weight: 500;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        padding: 12px 20px;
        font-size: 14px;
        border-radius: 4px;
        color: #fff;
        background-color: rgb(103, 194, 58) !important;
        border-color: rgb(103, 194, 58) !important;
      }

      .label-success:hover {
        background-color: rgb(133, 206, 97) !important;
        border-color: rgb(133, 206, 97) !important;
      }

      .dialogStoreComm {
        .el-dialog {
          width: 500px !important;
          height: 660px !important;

          .el-dialog__header {
            padding: 20px;
            border-bottom: 1px solid #EBEEF5;
          }

          .el-dialog__body {
            padding: 20px;
          }
        }
      }

      .drawerText {
        margin-bottom: 5px;
        height: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(77, 77, 77, 1);
        line-height: 16px;
      }

      h4 {
        font-size: 16px;
        color: #000;
        font-weight: normal;
        padding-top: 8px;
      }

      .contentTop {
        padding: 15px 0 24px 20px;

        .el-checkbox {
          margin-right: 30px;
        }
      }

      .infoForm {
        padding: 15px 0 0 20px;

        .parent {
          width: 50%;
          vertical-align: top;
          display: inline-block;
        }
      }
    }

    /*修改按钮样式*/
    .el-button--primary {
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      padding: 7px 20px;
      margin-bottom: 15px;
      margin-left: 0;
    }

    .colorRed {
      color: red;
    }

    .el-textarea__inner {
      font: 400 13.3333px Arial;
    }
  }

  .el-range-editor.el-input__inner {
    width: 320px;
  }

  .el-textarea {
    textarea {
      height: 124px;
    }
  }
</style>
